import { useContext } from 'react';

import { TeamsClientContext, TeamsClientOptions } from './context';

type UseTeamsClientContext = () => TeamsClientOptions;
export const useTeamsClientContext: UseTeamsClientContext = () => useContext(TeamsClientContext);
